import { render } from "./TabLayout.vue?vue&type=template&id=7c63c2c9&scoped=true"
import script from "./TabLayout.vue?vue&type=script&lang=js"
export * from "./TabLayout.vue?vue&type=script&lang=js"

import "./TabLayout.vue?vue&type=style&index=0&id=7c63c2c9&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c63c2c9"]])

export default __exports__